import React, { useMemo } from 'react';
import { UpcomingBooking } from '../../../../contexts/DashboardContext';
import { getUpcomingCheckInDiffDays } from '../../../../utils/dashboard/dashbordUtils';
import useTranslate from '../../../../customHooks/useTranslate';
import routes from '../../../../utils/commonVariables/routes';
import { useHistory } from 'react-router-dom';
import encodeBase64 from '../../../../utils/encodeBase64';

const UpcomingCheckInsItem = ({ booking }: { booking: UpcomingBooking }) => {
    const translate = useTranslate();
    const history = useHistory();
    const diffDays = getUpcomingCheckInDiffDays(booking.CheckInDate);
    const checkInDaySubtitle = useMemo(() => {
        if (diffDays === 0) {
            return translate('today');
        } else if (diffDays === 1) {
            return translate('tomorrow');
        } else {
            return `${translate('in')} ${diffDays} ${translate(
                diffDays > 1 ? 'days' : 'day'
            )}`;
        }
    }, [booking.CheckInDate]);

    return (
        <li
            className='next-bookings__item cursor-pointer'
            onClick={() =>
                history.push(
                    `${routes.landingPrivate}${routes.booking}/${encodeBase64(
                        booking.Id
                    )}`
                )
            }
        >
            <div className='date-stub'>
                {/* {checkInDiffDays ? ( */}
                <span
                    className={`date-eyebrow ${
                        diffDays === 0
                            ? '--today'
                            : diffDays === 1
                            ? '--tomorrow'
                            : ''
                    }`}
                >
                    {checkInDaySubtitle}
                </span>

                <span className='date-day'>
                    {new Date(booking.CheckInDate).getDate()}
                </span>
                <span className='date-month'>
                    {new Date(booking.CheckInDate).toLocaleString('default', {
                        month: 'short',
                    })}
                </span>
            </div>
            <div className='booking-info'>
                <p className='booking-code'>{booking.BookingCode}</p>
                <p className='booking-hotel'>{booking.SupplierHotel}</p>
            </div>
            <div className='booking-meta'>
                <span className='nights'>
                    {booking.Nights}{' '}
                    {translate(booking.Nights > 1 ? 'nights' : 'night')}
                </span>
            </div>
        </li>
    );
};

export default UpcomingCheckInsItem;
